import { useState, useCallback, useEffect } from 'react';
import { Table, TableHeader, TableBody, Column, Row, Cell } from 'react-aria-components';
import { Toaster } from 'react-hot-toast';

import { getLineUsers } from '@/api/getLineUsers';
import Button from '@/components/Button/Button';
import { EditLineUserDialog } from '@/components/lineUsers/EditLineUserDialog';
import { LineAccountUser } from '@/types/user';

export const LineAccountPage = () => {
  const [lineUsers, setLineUsers] = useState<LineAccountUser[]>([]);
  const [selectedUser, setSelectedUser] = useState<LineAccountUser | undefined>(undefined);
  const [isEditOpenDialog, setIsEditOpenDialog] = useState(false);

  const fetchLineUsers = useCallback(async () => {
    try {
      const result = await getLineUsers();
      if (result.status === 200) {
        setLineUsers(result.result);
      }
    } catch (error) {
      console.log('error');
    }
  }, []);

  useEffect(() => {
    fetchLineUsers();
  }, []);

  return (
    <div className="flex flex-col">
      <Table className="w-full border-collapse border border-gray-200">
        <TableHeader>
          <Column
            isRowHeader
            className="border border-gray-200 bg-gray-50 px-4 py-2 font-medium"
          >
            運営者ID
          </Column>
          <Column className="border border-gray-200 bg-gray-50 px-4 py-2 font-medium">
            運営者名
          </Column>
          <Column className="border border-gray-200 bg-gray-50 px-4 py-2 font-medium">
            保護者ID
          </Column>
          <Column className="border border-gray-200 bg-gray-50 px-4 py-2 font-medium">
            保護者名
          </Column>
          <Column className="border border-gray-200 bg-gray-50 px-4 py-2 font-medium"></Column>
        </TableHeader>
        <TableBody>
          {lineUsers.map((lineUser, index) => (
            <Row key={index}>
              <Cell
                key="staff_id"
                className="border border-gray-200 px-4 py-2 font-medium"
              >
                {lineUser.staff_id}
              </Cell>
              <Cell
                key="staff_name"
                className="border border-gray-200 px-4 py-2 font-medium"
              >
                {lineUser.staff_name}
              </Cell>
              <Cell
                key="guardian_id"
                className="border border-gray-200 px-4 py-2 font-medium"
              >
                {lineUser.guardian_id}
              </Cell>
              <Cell
                key="guardian_name"
                className="border border-gray-200 px-4 py-2 font-medium"
              >
                {lineUser.guardian_name}
              </Cell>
              <Cell
                key="edit"
                className="border border-gray-200 px-4 py-2 font-medium"
              >
                <Button
                  size="sm"
                  variant="text"
                  type="submit"
                  onClick={() => {
                    setIsEditOpenDialog(true);
                    setSelectedUser(lineUser);
                  }}
                >
                  編集
                </Button>
              </Cell>
            </Row>
          ))}
        </TableBody>
      </Table>
      <EditLineUserDialog
        isOpen={isEditOpenDialog}
        setIsOpen={setIsEditOpenDialog}
        afterSubmit={() => {
          fetchLineUsers();
        }}
        lineUser={selectedUser}
      />
      <Toaster />
    </div>
  );
};
